import { useQuery } from '@tanstack/react-query';

import {
  payCalendarsService,
  FetchPayCalendarsRequest,
  FetchPayCalendarsResponse,
  useToast,
} from '@aslanpay/portal-common-lib';

const useFetchPayCalendars = ({
  ids,
  status,
  payFrequency,
  payday,
  payType,
  companyId,
  friendlyId,
  startDateBefore,
  startDateAfter,
  query,
  sortBy,
  sort,
  hasNonSalariedEmployees,
  page,
  size,
}: FetchPayCalendarsRequest) => {
  const toast = useToast();

  return useQuery<FetchPayCalendarsResponse, Error>(
    [
      'fetchPayCalendars',
      ids,
      status,
      payFrequency,
      payday,
      payType,
      companyId,
      friendlyId,
      startDateBefore,
      startDateAfter,
      query,
      sortBy,
      sort,
      hasNonSalariedEmployees,
      page,
      size,
    ],
    () =>
      payCalendarsService.fetchPayCalendars({
        ids,
        status,
        payFrequency,
        payday,
        payType,
        companyId,
        friendlyId,
        startDateBefore,
        startDateAfter,
        query,
        sortBy,
        sort,
        hasNonSalariedEmployees,
        page,
        size,
      }),
    {
      onError: () => {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Something went wrong',
          description: `Sorry, we failed to fetch the pay calendars. Please try again.`,
        });
      },
    }
  );
};

export default useFetchPayCalendars;
